import type { Goal, ProjectedWeight } from "shared/types";
import {
  GET_LOT_WEIGHT_PROJECTION,
  LIST_LOT_GOALS,
  type LotActionsDispatchAction,
} from "../actions/lotActions";

export type LotState = {
  goals: Goal[];
  lotWeightProjection: ProjectedWeight | null;
};

export const initialState: LotState = {
  goals: [],
  lotWeightProjection: null,
};

export default function lotReducer(
  state: LotState = initialState,
  action: LotActionsDispatchAction
): LotState {
  if (action.type === GET_LOT_WEIGHT_PROJECTION) {
    return {
      ...state,
      lotWeightProjection: action.payload.projectedWeight,
    };
  }

  if (action.type === LIST_LOT_GOALS) {
    return {
      ...state,
      goals: action.payload.goals,
    };
  }

  return { ...state };
}
